import cloneDeep from 'lodash/cloneDeep';
import { call, select } from 'redux-saga/effects';

import { getPaymentOptions, getFinanceOptions } from '../selectors';
import updatePaymentOptions from './api/updatePaymentOptions';

/**
 * @param {Object} payload - Data from action
 */
function* selectPayment(payload) {
    const paymentOptions = yield select(getPaymentOptions);
    const financeOptions = yield select(getFinanceOptions);
    const { cashDown, index, term } = payload;

    // Deep copy
    const transformedFinanceOptions = cloneDeep(financeOptions);

    // Update isSelected values
    transformedFinanceOptions.forEach((fo, i) => {
        fo.isSelected = i === index;
    });

    // Update selected financeOptions
    transformedFinanceOptions[index].selectedTerm = term;
    transformedFinanceOptions[index].selectedCashDown = cashDown;

    // Take data from the targeted financeOptions
    const {
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        purchaseMethod
    } = transformedFinanceOptions[index];

    yield call(updatePaymentOptions, {
        ...paymentOptions,
        cashDown,
        financeOptions: transformedFinanceOptions,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        purchaseMethod,
        term
    });
}

export default selectPayment;
